document.getElementById('getQuoteButton').addEventListener('click', function() {
  var quoteButton = document.getElementById('getQuoteButton');
  var phoneNumber = document.getElementById('phoneNumber');

  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    // Redirect to a phone call on mobile devices
    window.location.href = 'tel:+1-450-679-6380 #4184';
  } else {
    // Show the phone number on desktop
    phoneNumber.style.display = 'inline';
    // Hide the "Get a Quote Today" button on desktop
    quoteButton.style.display = 'none';
  }
});

